export const LocalStorageKeys = {
	PublicHomePageHideWelcomeCard: "home-page-hide-welcome-card",
	PublicEntHomePageHideWelcomeCard: "ent-home-page-hide-welcome-card",
	PublicVolHomePageHideWelcomeCard: "vol-home-page-hide-welcome-card",
	PublicQuestionnaireInitialUrl: "questionnaire-initial-url",
	PublicHomePageHideAdvisorCard: "home-page-hide-advisor-card",
	PublicVolScheduleInterviewClicked: "vol-schedule-interview",
	PublicVolAttendOrientationClicked: "vol-attend-orientation",
	PublicCohortNextSteps: "cohort-next-steps",
}